import React from "react";
import { Layout, Menu } from "antd";
import { Route, Switch, Link, Redirect } from "react-router-dom";
import RouteList from "Routes/private/list";
const { Sider, Content } = Layout;

export default function UserProfileLayout({ ...props }) {
  const path = "/panel/kullanici";
  const routes =
    RouteList[0].children.find((f) => {
      return f.name === "Kullanıcı";
    })?.children || [];

  return (
    <>
      <Layout>
        <Sider>
          <Menu>
            {routes.map((item) => (
              <Menu.Item key={item.name}>
                <Link to={`${path}${item.path}`}>{item.name}</Link>
              </Menu.Item>
            ))}
          </Menu>
        </Sider>
        <Content>
          <Switch>
            <Route
              path={path}
              exact={true}
              component={() => <Redirect to={`${path}/profil`} />}
            />
            {routes.map((item) => (
              <Route
                key={item.name}
                component={item.component}
                path={`${path}${item.path}`}
              />
            ))}
          </Switch>
        </Content>
      </Layout>
    </>
  );
}
